import SectionHeading from "@/components/feature/SectionHeading";
import FeatureGrid from "@/components/feature/FeatureGrid";
import { nxhostDifferentials } from "@/mocks/criacao-sites";

export default function Differentials() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Diferenciais"
          badgeIcon="ri-vip-diamond-line"
          title="Por que criar seu site com a NXHOST?"
          description="Tecnologia, estratégia e atendimento próximo em cada etapa do projeto."
        />
        <div className="mt-12">
          <FeatureGrid items={nxhostDifferentials} columns={4} accent="accent" />
        </div>
      </div>
    </section>
  );
}